import { responsive, spacing, ThemeUICSSObject } from '@apia/theme';
import configurationMenu from './configurationMenu';
/* IMPORT HERE */

const topBar: ThemeUICSSObject = {
  backgroundColor: 'topBar.backgroundColor',
  color: 'white',
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 0,
  flexShrink: 0,
  justifyContent: responsive({ 0: 'space-between', 3: 'stretch' }),
  position: 'relative',
  zIndex: 'stickyElements',

  '.main__menu': {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
  },

  '.main__confMenu': configurationMenu,

  '.main__languagesSelector': {
    svg: {
      path: {
        fill: 'none',
      },
    },
  },

  '.main__tabsList': {
    flexGrow: 1,
  },

  '.tabs__list': {
    display: responsive({ 0: 'none', 3: 'flex' }),
  },

  'button:not(.tabs__item__close, .menu__openTask, .menu__toggleFavoriteButton, .tabs__item__wrapper, .closeButton)':
    (theme) => ({
      border: 'none',
      ...theme.palette.getStatesFromDefinition({
        backgroundColor: 'topBar.backgroundColor',
        color: 'white',
      }),
    }),

  '.mainCategory, .menu__openTask, .tree__mainLabel': {
    fontSize: 18,
  },

  '[role="treeitem"]:focus-within > .tree__nodeItemLabel': {
    background: 'rgba(0,0,0,0.05)',
  },

  '.main__serverTime': {
    px: spacing(3),
    height: '100%',
  },
  '.user__img': {
    maxHeight: '24px',
    maxWidth: ' 24px',
  },

  '.tabsList__fixedTabs': {
    display: responsive({ 0: 'none', 3: 'flex' }),
  },

  '.mobile_tabs_list.tabs__item__button.open': (theme) => ({
    display: responsive({ 0: 'block', 3: 'none' }),
    zIndex: 1,

    ...theme.palette.getStatesFromDefinition(
      {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
      },
      {
        states: { selected: false },
        mergeObject: {
          '&:focus-within': {
            backgroundColor: theme.palette.background.paper,
          },
        },
      },
    ),

    borderRadius: 0,
  }),

  /* PREPEND HERE */
};

export default topBar;
